import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fixes SPA hash scrolling: when a route changes to `/some-page#section`,
// React mounts the page AFTER the URL is set, so the browser's native
// hash-scroll fires too early. This waits for the target element to exist
// then smooth-scrolls to it.
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      // No hash → scroll to top on route change (SPA default behaviour)
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      return;
    }
    const id = hash.slice(1);
    // Poll briefly for the element (up to ~1.5s) in case it renders lazily.
    let attempts = 0;
    const tick = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (attempts++ < 15) setTimeout(tick, 100);
    };
    tick();
  }, [pathname, hash]);

  return null;
}
